module.exports = __webpack_public_path__ + "static/img/7.c2dc790.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/fgimg/7.jpg
// module id = SjfO
// module chunks = 18